/** How long the indicator keeps showing a call that ended with the customer connected. */
export const CALL_ENDED_HIDE_DELAY_MS = 6000;
